/*
 * External libraries to be pulled in as script tags for CDN usage.
 */
let mode = !process.env.ISDEV ? 'production.min' : 'development';

export default {
    // Remote JavaScript scripts.
    javascripts: {
        enabled: true,
        scripts: [
            {
                src: `https://unpkg.com/react@${ENVConfig.VERSIONS['react']}/umd/react.${mode}.js`,
                crossorigin: '',
                enabledIf: () => !window.React,
                waitFor: 'React',
            },
            {
                src: `https://unpkg.com/react-dom@${ENVConfig.VERSIONS['react-dom']}/umd/react-dom.${mode}.js`,
                crossorigin: '',
                enabledIf: () => !window.ReactDOM,
                waitFor: 'ReactDOM',
            },
            {
                src: `https://unpkg.com/react-router-dom@${ENVConfig.VERSIONS['react-router-dom']}/umd/react-router-dom.min.js`,
                crossorigin: '',
                enabledIf: () => !window.ReactRouterDOM,
                waitFor: 'ReactRouterDOM',
            },
            // Remote 3rd party libraries.
            {
                src: 'https://unpkg.com/rollbar@2.14.2/dist/rollbar.umd.min.js',
                crossorigin: '',
                enableIf: () =>
                    ENVConfig.rollbar?.accessToken && !window.rollbar,
                onload: () => {
                    window.ErrorReporter = new rollbar({
                        ...{
                            captureUncaught: true,
                            captureUnhandledRejections: true,
                        },
                        ...ENVConfig.rollbar,
                    });
                    if (window.ErrorReporter instanceof window.rollbar) {
                        window.ErrorReporter.warn = (...args) =>
                            window.ErrorReporter.warning.apply(
                                window.ErrorReporter,
                                args
                            );
                        window.ErrorReporter.trace = (...args) =>
                            window.ErrorReporter.critical.apply(
                                window.ErrorReporter,
                                args
                            );
                    } else {
                        console.warn(
                            'WARNING: Rollbar not configured; using console.* methods!'
                        );
                    }
                },
            },
            {
                enabled: false,
                src: 'https://unpkg.com/axios@0.18.0/dist/axios.min.js',
                integrity:
                    'sha384-U/+EF1mNzvy5eahP9DeB32duTkAmXrePwnRWtuSh1C/bHHhyR1KZCr/aGZBkctpY',
                crossorigin: 'anonymous',
                async: true,
                enabledIf: () => !window.axios,
            },
            // Remote polyfills, usually for IE 11.
            {
                enabled: false,
                src: 'https://unpkg.com/whatwg-fetch@3.0.0/dist/fetch.umd.js',
                integrity:
                    'sha384-FhKuW+ZR2hflgmnV7xCkMJCI8bMePuvlqAW0lizfVmOBLfWyB3Wk+dP6+47hN/rP',
                enabledIf: () => !window.fetch,
            },
            {
                src: 'https://unpkg.com/details-element-polyfill@2.4.0/dist/details-element-polyfill.js',
                integrity:
                    'sha384-e9xku4VSRQ/IhD1GrrEGl4DR0H68G1fI1qUeiY9f6aSYKSAQJDNWwLiBq8uZB7aD',
                enabledIf: () =>
                    !(
                        typeof HTMLDetailsElement !== 'undefined' &&
                        document.createElement('details') instanceof
                            HTMLDetailsElement
                    ),
            },
        ],
    },

    // Remote CSS stylesheets/webfonts.
    stylesheets: {
        enabled: true,
    },
};
